<div class="sidenav-trigger-buttons">
  <button (click)="handleSportBar()" mat-raised-button color="primary">
    <mat-icon>{{
      navService.openSportsBar.value ? "close" : "directions_bike"
    }}</mat-icon>
    {{ "Sports" | translate }}
  </button>
  <button (click)="handleBetSlip()" mat-raised-button color="primary">
    <mat-icon>{{
      navService.openBetSlipBar.value ? "close" : "settings"
    }}</mat-icon>
    {{ "Betslip" | translate }}
  </button>
</div>
<mat-drawer-container class="main-wrapper" hasBackdrop="false">
  <mat-drawer
    disableClose="true"
    class="sports-wrapper"
    mode="side"
    [opened]="navService.openSportsBar.value"
  >
    <router-outlet name="navigation"></router-outlet>
  </mat-drawer>
  <mat-drawer-content
    class="content-wrapper"
    [ngClass]="{
      'shrunk-right': navService.openBetSlipBar.value,
      'shrunk-left': navService.openSportsBar.value,
    }"
  >
    <router-outlet name="content"></router-outlet>
  </mat-drawer-content>
  <mat-drawer
    disableClose="true"
    class="bet-slip-wrapper"
    [mode]="rightDrawerMode"
    [opened]="navService.openBetSlipBar.value"
    position="end"
  >
    <router-outlet name="betting"></router-outlet>
  </mat-drawer>
</mat-drawer-container>
